import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';

const SelectionNotAssigned = ({ raceName }) => (
    <Styled.Box>
        <Styled.BoxText>
            The {raceName} horses aren&#39;t quite ready yet. Check back here
            after <Styled.Highlighted>2pm</Styled.Highlighted> on{' '}
            <Styled.Highlighted>Thursday 9th April</Styled.Highlighted> to find
            out your horse.
        </Styled.BoxText>
    </Styled.Box>
);

SelectionNotAssigned.propTypes = {
    raceName: PropTypes.string.isRequired
};

export default SelectionNotAssigned;
